/** Human-readable label for a PGN UTCDate value (e.g. "2024.01.15"). */
export function formatUtcDateLabel(
  utcDate?: string | null,
): string | null {
  const trimmed = utcDate?.trim();
  if (!trimmed) {
    return null;
  }

  const isoDate = trimmed.replace(/\./g, '-');
  const parsed = new Date(`${isoDate}T00:00:00Z`);
  if (Number.isNaN(parsed.getTime())) {
    return trimmed;
  }

  return parsed.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
